import config from './config.js'

export default {

  templates: function(ctrl,cb_success) {
    config.get(ctrl,config.baseUrl + 'rest/documents/templates','Lade Office Vorlagen',cb_success);
  },

}
